import React, { useEffect } from 'react';
import { Typography, Card } from 'antd';
import AverageTagSmall from '../components/averageTagSmall/averageTagSmall';
import IndividualInformHeader from '../components/individualInformHeader/individualInformHeader';
import LeadershipByDimensionsIndividual from '../components/leadershipByDimensionsIndividual/leadershipByDimensionsIndividual';
import LeadershipNPSIndividual from '../components/leadershipNPSIndividual/leadershipNPSIndividual';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';
import { getEvaluationScoreColor } from '../components/selfcare360/selfcare360Scales';

const { Title } = Typography;

const PageResultsByDimensionIndividual = ({
    selectedEvaluation,
    totalResults,
    individualResult,
    orgLogo,
    pageNumber,
    indexPage,
    title,
    chartGroups,
    globalAverage,
    orgGlobalAverage,
    color,
    type,
    dimension,
    totalQuestions,
}) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const getColor = (value) => getEvaluationScoreColor(value, {
        redLight: selectedEvaluation.evl_max_red_light,
        yellowLight: selectedEvaluation.evl_max_yellow_light,
        serviceId: selectedEvaluation?.evl_srv_id,
    });

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info" style={{ position: "relative" }}>
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    <AverageTagSmall
                        average={globalAverage}
                        color={getColor(globalAverage)}
                        type={2}
                        isNps={type === 2}
                    />

                    <Card
                        style={{
                            border: 'none',
                            backgroundColor: 'white',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '0' } }}
                    >
                        <Title
                            level={4}
                            style={{ color: '#339C98', marginBottom: 16, width: 'calc(100% - 150px)' }}
                        >
                            {title}
                        </Title>
                        {type === 1 && (
                            <LeadershipByDimensionsIndividual
                                chartGroups={chartGroups}
                                globalAverage={globalAverage}
                                orgGlobalAverage={orgGlobalAverage}
                                dimension={dimension}
                                redLight={selectedEvaluation.evl_max_red_light}
                                yellowLight={selectedEvaluation.evl_max_yellow_light}
                                color={color}
                                type={type}
                                indexPage={indexPage}
                            />
                        )}
                    </Card>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResultsByDimensionIndividual;
